export const INIT_LOGOUT = 'accionInitLogout';
export const FINISH_LOGOUT = 'accionFinishLogout';

export const inittLogout = () => ({
    type: INIT_LOGOUT
});

export const finishLogout = () => ({
    type: FINISH_LOGOUT
});